import React from 'react'
import './Text.css'

function Text(props) {
    
  return (
    <>
        <div className='d-flex justify-content-between w-100'>
            <input
                value={props.value}
                onChange={props.onChange}
                placeholder={props.placeholder}
                className='inpTxt w-w-fill me-2'
            />
            <p className='mb-0 ms-3 d-flex align-items-end colorGray02'>{props.value?props.value?.length:0}/50</p>
        </div>
    </>
  )
}

export default Text;